import { render, staticRenderFns } from "./RulesDisplay.vue?vue&type=template&id=6e2d0020&"
import script from "./RulesDisplay.vue?vue&type=script&lang=js&"
export * from "./RulesDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports